import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuthContext } from '../../../../context/auth'
import Expert from '../Account/Expert'
import { usePageLeaveContext } from '../../../../context/pageLeave'
import { useAccountContext } from '../../../../context/account'
import { IAccount } from '../../../../context/types'
import { useExpertProfilesContext } from '../../../../context/expertProfile'
import SpinLoader from '../../../helpers/SpinLoader'

type UrlParam = {
	accountId: string
	channelName: string
}

export default function ExpertPages() {
	const { auth } = useAuthContext()
	const { actions } = usePageLeaveContext()
	const { account } = useAccountContext()
	const { actions: expertProfilesActions } = useExpertProfilesContext()
	const [loading, setLoading] = useState<boolean>(true)
	const [userData, setUserData] = useState<IAccount>()
	const { accountId, channelName } = useParams() as UrlParam

	useEffect(() => {
		return () => {
			actions.setConditions({})
		}
	}, [])

	useEffect(() => {
		if (userData?.user?.isExpert) {
			const token = account?.token && !!accountId ? account.token : null
			expertProfilesActions.setError()
			if (accountId) {
				expertProfilesActions.getExpertProfiles(token)
			}
		}
	}, [userData?.user?.isExpert])

	useEffect(() => {
		if (account.token) {
			setUserData(account)
			if (!account.loading && !auth.loading) setLoading(false)
		} else if (!account.loading && !account.token) {
			setUserData(auth)
			if (!account.loading && !auth.loading) setLoading(false)
		}
	}, [account, auth])

	return (
		<div className="profile-form_wrapper">
			<SpinLoader loading={!!loading || !!userData.loading}>
				{userData?.user?.isExpert && <Expert pageChannelName={channelName} />}
			</SpinLoader>
		</div>
	)
}
